import types, {baseAsyncTypes} from '../../actions/types'
import {createDataBlockReducer} from 'helpers/reducer'
import {combineReducers} from 'redux'
import {get, isNil, unionBy} from 'lodash'
import {TYPE} from 'helpers/contacts'
import {deleteTeam} from 'helpers/data'

export const companyFields = (state = [], action) => {
  switch (action.type) {
    case types.CONTACTS_LOAD_COMPANY_DATA_FIELDS_SUCCESS:
      return action.data || []

    case types.SETTINGS_USER_SETTING_UPDATE_SUCCESS:
      if (state && state.length > 0) {
        const required = get(action, 'data.contactAddRequiredFields.required')
        if (required) {
          return state.map(field => {
            switch (field.key) {
              case 'c_website':
                return {...field, mandatory: !!required.CONTACT_ADD_WEBSITE}
              case 'c_businessTypeId':
                return {...field, mandatory: !!required.CONTACT_ADD_BUSINESS_TYPE}
              case 'c_accountNumber':
                return {...field, mandatory: !!required.CONTACT_ADD_ACCOUNT_NUMBER}
              case 'c_groups':
                return {...field, mandatory: !!required.CONTACT_ADD_GROUPS}
              default:
                return field
            }
          })
        }
      }
      break

    default:
      return state
  }
}

export const contactFields = (state = [], action) => {
  switch (action.type) {
    case types.CONTACTS_LOAD_CONTACT_DATA_FIELDS_SUCCESS:
      return action.data || []

    case types.SETTINGS_USER_SETTING_UPDATE_SUCCESS:
      if (state && state.length > 0) {
        const required = get(action, 'data.contactAddRequiredFields.required')
        if (required) {
          return state.map(field => {
            switch (field.key) {
              case 'f_phone':
                return {...field, mandatory: !!required.CONTACT_ADD_PHONE}
              case 'f_mobile':
                return {...field, mandatory: !!required.CONTACT_ADD_MOBILE}
              case 'f_email':
                return {...field, mandatory: !!required.CONTACT_ADD_EMAIL}
              case 'f_jobTitle':
                return {...field, mandatory: !!required.CONTACT_ADD_JOB_TITLE}
              case 'f_accountManagerId':
                return {...field, mandatory: !!required.CONTACT_ADD_ACCOUNT_MANAGER}
              case 'f_source':
                return {...field, mandatory: !!required.CONTACT_ADD_LEAD_SOURCE}
              case 'f_salutation':
                return {...field, mandatory: !!required.CONTACT_ADD_SALUTATION}
              default:
                return field
            }
          })
        }
      }
      return state

    default:
      return state
  }
}

export const individualFields = (state = [], action) => {
  switch (action.type) {
    case types.CONTACTS_LOAD_INDIVIDUAL_DATA_FIELDS_SUCCESS:
      return action.data || []

    case types.SETTINGS_USER_SETTING_UPDATE_SUCCESS:
      if (state && state.length > 0) {
        const required = get(action, 'data.contactAddRequiredFields.required')
        if (required) {
          return state.map(field => {
            switch (field.key) {
              case 'f_phone':
                return {...field, mandatory: !!required.CONTACT_ADD_PHONE}
              case 'f_mobile':
                return {...field, mandatory: !!required.CONTACT_ADD_MOBILE}
              case 'f_email':
                return {...field, mandatory: !!required.CONTACT_ADD_EMAIL}
              case 'f_jobTitle':
                return {...field, mandatory: !!required.CONTACT_ADD_JOB_TITLE}
              case 'f_accountManagerId':
                return {...field, mandatory: !!required.CONTACT_ADD_ACCOUNT_MANAGER}
              case 'f_source':
                return {...field, mandatory: !!required.CONTACT_ADD_LEAD_SOURCE}
              case 'f_salutation':
                return {...field, mandatory: !!required.CONTACT_ADD_SALUTATION}
              case 'c_website':
                return {...field, mandatory: !!required.CONTACT_ADD_WEBSITE}
              case 'c_businessTypeId':
                return {...field, mandatory: !!required.CONTACT_ADD_BUSINESS_TYPE}
              case 'c_accountNumber':
                return {...field, mandatory: !!required.CONTACT_ADD_ACCOUNT_NUMBER}
              case 'c_groups':
                return {...field, mandatory: !!required.CONTACT_ADD_GROUPS}
              default:
                return field
            }
          })
        }
      }
      break
    default:
      return state
  }
}

export const fieldOptions = (state = [], action) => {
  switch (action.type) {
    case types.CONTACTS_GET_FIELD_OPTIONS_SUCCESS: {
      // Merge in the new/updated field options
      return unionBy(action.data, state, field => field.key)
    }
    default:
      return state
  }
}

export const taxCodes = (state = [], action) => {
  const data = Object.assign({}, state)
  switch (action.type) {

    case types.SETTINGS_TAX_CODE_SET_DEFAULT_SUCCESS:
    case types.SETTINGS_TAX_CODE_UPDATE_SUCCESS:
    case types.DATA_LOAD_TAX_CODES_SUCCESS:
      return action.data

    case types.ACCOUNTING_TAX_CODE_LINK_SUCCESS:
      return Object.keys(data).map(i => {
        const taxCode = data[i]
        if (action.result.hasOwnProperty(taxCode.code)) {
          const {accountingTaxCode, rate} = action.result[taxCode.code]
          return {
            ...taxCode,
            xeroCode: accountingTaxCode,
            accountingSalesCode: accountingTaxCode,
            rate: rate,
          }
        } else {
          return taxCode
        }
      })

    case types.ACCOUNTING_TAX_CODE_LINK_FAILURE:
      return state

    default:
      return state
  }
}

export const currencies = (state = [], action) => {
  switch (action.type) {
    case types.SETTINGS_CURRENCY_ENABLE_SUCCESS:
    case types.SETTINGS_CURRENCY_READ_SUCCESS:
    case types.SETTINGS_CURRENCY_REMOTE_UPDATE_SUCCESS:
    case types.SETTINGS_CURRENCY_UPDATE_SUCCESS:
    case types.DATA_LOAD_CURRENCIES_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const defaultCurrencies = (state = []) => {
  return state
}

export const referralFeeValues = (state = {}, action) => {
  switch (action.type) {
    case types.SETTINGS_REFERRAL_TYPE_APPLY_SUCCESS:
      return action.data
    case types.SETTINGS_REFERRAL_TYPE_READ_SUCCESS:
      return action.data
    case types.SETTINGS_REFERRAL_TYPE_CLEAR_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const countries = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_COUNTRIES_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const businessTypes = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_BUSINESS_TYPES_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const companyGroups = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_COMPANY_GROUPS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const products = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_PRODUCTS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const campaigns = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_CAMPAIGNS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const campaignGroups = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_CAMPAIGN_GROUPS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const homeContacts = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_HOME_CONTACTS_SUCCESS:
      return action.data
    case types.CONTACTS_CONTACT_ADD_SUCCESS: {
      const homeCompanyId = get(state[0], 'companyId', null)
      const companyId = get(action, 'data.companyId', null)
      return homeCompanyId === companyId
          ? [...state, action.data]
          : state
    }
    case types.CONTACTS_CONTACT_EDIT_SUCCESS: {
      const homeCompanyId = get(state[0], 'companyId', null)
      const updatedContact = action.data
      const companyId = get(updatedContact, 'companyId', null)
      const contactId = get(updatedContact, 'id', null)
      return state.map(homeContact => {
        return (
            homeCompanyId === companyId &&
            homeContact.id === contactId
        )
            ? updatedContact
            : homeContact
      })
    }
    case types.CONTACTS_CONTACT_DELETE_SUCCESS: {
      const homeCompanyId = get(state[0], 'companyId', null)
      return homeCompanyId === action.companyId
          ? state.filter(homeContact => homeContact.id !== action.contactId)
          : state
    }
    case types.CONTACTS_CONTACT_DORMANT_SUCCESS: {
      return state.map(homeContact => {
        return {
          ...homeContact,
          type: homeContact.id === action.contactId
              ? TYPE.dormant
              : homeContact.type,
        }
      })
    }

    case types.CONTACTS_CONTACT_LIVE_SUCCESS: {
      return state.map(homeContact => {
        return {
          ...homeContact,
          type: homeContact.id === action.contactId
              ? TYPE.general
              : homeContact.type,
        }
      })
    }
    default:
      return state
  }
}

export const orderReasons = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_ORDER_REASONS_SUCCESS:
      return action.data
    default :
      return state
  }
}

export const orderTypes = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_ORDER_TYPES_SUCCESS:
      return action.data
    default :
      return state
  }
}

export const nominalCodes = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_NOMINAL_CODES_SUCCESS:
      return action.data
    default :
      return state
  }
}

export const prefixTypes = (state = [], action) => {
  switch (action.type) {
    case types.STATE_LOAD_SUCCESS:
      return action.data.data.prefixTypes || state
    default:
      return state
  }
}

const translateContactList = (contactList) => {
  const {categoryId} = contactList
  // NULLify root category ID
  return {
    ...contactList,
    categoryId: categoryId < 0 ? null : categoryId,
  }
}

export const contactLists = (state = null, action) => {
  switch (action.type) {
    case types.DATA_LOAD_CONTACT_LISTS_SUCCESS:
      return action.data.map(cl => translateContactList(cl)) // translate -1 to NULL
    case types.CONTACT_LISTS_ADD_LIST_SUCCESS:
      return [...(state || []), translateContactList(action.data)]
    case types.CONTACT_LISTS_UPDATE_LIST_SUCCESS:
      return (state || []).map(cl => (cl.id === action.data.id) ? action.data : cl)
    case types.CONTACT_LISTS_DELETE_LIST_SUCCESS:
      return (state || []).filter(cl => cl.id !== action.list.id)
    case types.CONTACT_LISTS_REQUERY_LISTS_ATTEMPT: {
      if (state == null) return state
      const {listIds} = action
      return state.map(cl => {
        if (listIds.indexOf(cl.id) >= 0) return {...cl, summary: {}, loading: true} // provide a blank summary to prevent re-loading again
        return cl
      })
    }
    case types.CONTACT_LISTS_REQUERY_LISTS_SUCCESS: {
      if (state == null) return state
      const {listIds, data} = action
      return state.map(cl => {
        if (listIds.indexOf(cl.id) >= 0) {
          return {
            ...cl,
            summary: data[cl.id],
            loading: false,
          }
        }
        return cl
      })
    }
    case types.CONTACT_LISTS_REQUERY_LISTS_FAILURE: {
      if (state == null) return state
      const {listIds} = action
      return state.map(cl => {
        if (listIds.indexOf(cl.id) >= 0) return {...cl, loading: false}
        return cl
      })
    }
    case types.CONTACT_LISTS_DORMANT_CONTACTS_ATTEMPT: {
      if (state == null) return state
      const {list} = action
      return state.map(cl => {
        if (cl.id === list.id) return {...list, loading: true}
        return cl
      })
    }
    case types.CONTACT_LISTS_DORMANT_CONTACTS_FAILURE:
    case types.CONTACT_LISTS_DORMANT_CONTACTS_SUCCESS: {
      if (state == null) return state
      const {list} = action
      return state.map(cl => {
        if (cl.id === list.id) return {...list, loading: false}
        return cl
      })
    }
    case types.CONTACT_LISTS_DELETE_CATEGORIES_SUCCESS: {
      const {categories, adoptCategoryId} = action
      return state.map(cl => {
        if (cl.categoryId && categories.indexOf(cl.categoryId) >= 0) return {...cl, categoryId: adoptCategoryId}
        return cl
      })
    }
    default:
      return state
  }
}

export const contactListCategories = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_CONTACT_LIST_CATEGORIES_SUCCESS:
      return action.data
    case types.CONTACT_LISTS_ADD_CATEGORY_SUCCESS:
      return [...state, action.data]
    case types.CONTACT_LISTS_UPDATE_CATEGORY_SUCCESS:
      return state.map(c => c.id === action.data.id ? action.data : c)
    case types.CONTACT_LISTS_DELETE_CATEGORIES_SUCCESS:
      return state.filter(c => action.categories.indexOf(c.id) < 0)
    default:
      return state
  }
}

export const printTemplates = (state = [], action) => {
  switch (action.type) {
    case types.PRINT_TEMPLATES_ADD_PRINT_TEMPLATE_SUCCESS:
      return [
        ...state,
        action.data,
      ]
    case types.PRINT_TEMPLATES_DUPLICATE_PRINT_TEMPLATE_SUCCESS:
      return [
        ...state,
        action.data,
      ]
    case types.PRINT_TEMPLATES_UPDATE_PRINT_TEMPLATE_SUCCESS:
      return state.map(printTemplate => {
        return printTemplate.id === action.printTemplate.id
            ? action.printTemplate
            : printTemplate
      })
    case types.PRINT_TEMPLATES_DELETE_PRINT_TEMPLATE_SUCCESS:
      return state.filter(printTemplate => printTemplate.id !== action.data)
    case types.PRINT_TEMPLATES_LOAD_PRINT_TEMPLATES_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const printTemplateGroups = (state = [], action) => {
  switch (action.type) {
    default:
      return state
  }
}

export const sendAddresses = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_SEND_ADDRESSES_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_ADD_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_DELETE_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_SET_DEFAULT_SUCCESS:
      return action.data.sendAddresses
    default:
      return state
  }
}

export const maxSendAddresses = (state = null, action) => {
  switch (action.type) {
    case types.DATA_LOAD_SEND_ADDRESSES_SUCCESS:
      return action.data.maxSendAddresses || null
    case types.SETTINGS_SEND_ADDRESS_ADD_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_DELETE_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_SET_DEFAULT_SUCCESS:
      return !isNil(action.data.maxSendAddresses)
          ? action.data.maxSendAddresses
          : state
    default:
      return state
  }
}

export const additionalSendAddressDomains = (state = null, action) => {
  switch (action.type) {
    case types.DATA_LOAD_SEND_ADDRESSES_SUCCESS:
      return action.data.additionalSendAddressDomains || null
    case types.SETTINGS_SEND_ADDRESS_ADD_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_DELETE_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_SET_DEFAULT_SUCCESS:
      return !isNil(action.data.additionalSendAddressDomains)
          ? action.data.additionalSendAddressDomains
          : state
    default:
      return state
  }
}

export const isDomainRestricted = (state = true, action) => {
  switch (action.type) {
    case types.DATA_LOAD_SEND_ADDRESSES_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_ADD_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_DELETE_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_SET_DEFAULT_SUCCESS:
      return action.data.isDomainRestricted
    default:
      return state
  }
}

export const baseEmailDomain = (state = '', action) => {
  switch (action.type) {
    case types.DATA_LOAD_SEND_ADDRESSES_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_ADD_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_DELETE_SUCCESS:
    case types.SETTINGS_SEND_ADDRESS_SET_DEFAULT_SUCCESS:
      return action.data.baseEmailDomain
    default:
      return state
  }
}

export const textTemplates = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_TEXT_TEMPLATES_SUCCESS:
      return action.data
    case types.DATA_CREATE_TEXT_TEMPLATE_SUCCESS:
      return [...state, action.data[0]]
    default:
      return state
  }
}

export const quotationFields = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_QUOTING_DATA_FIELDS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const quotationItemFields = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_QUOTE_ITEM_DATA_FIELDS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const purchasingFields = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_PURCHASING_DATA_FIELDS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const purchasingItemFields = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_PURCHASING_ITEM_DATA_FIELDS_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const contactMethods = (state = [], action) => {
  switch (action.type) {
      // Optimistic add
    case types.CONTACTS_CONTACT_METHOD_ADD_ATTEMPT:
      return [...state, action.contactMethod]
      // Confirmed add
    case types.CONTACTS_CONTACT_METHOD_ADD_SUCCESS:
      return [...state.filter(m => !!m.id), action.data]
      // Failed add
    case types.CONTACTS_CONTACT_METHOD_ADD_FAILURE:
      return state.filter(m => !!m.id)
      // Optimistic update
    case types.CONTACTS_CONTACT_METHOD_EDIT_ATTEMPT:
      return state.map(m => m.id === action.contactMethod.id ? {...m, ...action.contactMethod} : m)
      // Confirmed update
    case types.CONTACTS_CONTACT_METHOD_EDIT_SUCCESS:
      return state.map(m => m.id === action.data.id ? action.data : m)
      // Optimistic delete
    case types.CONTACTS_CONTACT_METHOD_DELETE_ATTEMPT:
      return state.filter(m => m.id !== action.id)
    default:
      return state
  }
}

export const stateLoaded = (state = false, action) => {
  switch (action.type) {
    case types.STATE_LOAD_SUCCESS:
      return true
    default:
      return state
  }
}

export const accountPackages = (state = [], {type, data}) => {
  if (type === types.DATA_LOAD_ACCOUNT_PACKAGES_SUCCESS) {
    return data
  } else {
    return state
  }
}

export const billingDetails = (state = null, action) => {
  switch (action.type) {
    case types.BILLING_DETAILS_LOAD_SUCCESS:
      return action.data
    case types.BILLING_DETAILS_UPDATE_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const billingInvoices = (state = [], action) => {
  switch (action.type) {
    case types.DATA_BILLING_INVOICES_LOAD_SUCCESS:
      return state.concat(get(action, 'data.invoices', []))
    default:
      return state
  }
}

export const hasMoreBillingInvoices = (state = false, action) => {
  switch (action.type) {
    case types.DATA_BILLING_INVOICES_LOAD_SUCCESS:
      return get(action, 'data.hasMore', false)
    default:
      return state
  }
}

export const homeCompanyLocations = (state = [], action) => {
  switch (action.type) {
    case types.DATA_HOME_COMPANY_LOCATIONS_LOAD_ATTEMPT:
      return []
    case types.DATA_HOME_COMPANY_LOCATIONS_LOAD_SUCCESS:
      return action.data
    case types.DATA_HOME_COMPANY_LOCATIONS_LOAD_FAILURE:
      return []
    default:
      return state
  }
}

export const packages = (state = [], {type, data}) => {
  if (type === types.DATA_LOAD_PACKAGES_SUCCESS) {
    return data
  } else {
    return state
  }
}

export const contactRoles = (state = []) => {
  return state  // loaded via hydration only
}

export const features = (state = []) => {
  return state  // loaded via hydration only
}

export const featureTogglesUri = (state = null) => {
  return state // loaded via hydration only
}

export const systemName = (state = null) => {
  return state  // loaded via hydration only
}

export const permissions = (state = []) => {
  return state  // loaded via hydration only
}

export const supportPhone = (state = '') => {
  return state  // loaded via hydration only
}

export const packTypes = (state = [], action) => {
  switch (action.type) {
    case types.DATA_LOAD_PACK_TYPES_SUCCESS:
      return action.data
  }
  return state  // loaded via hydration only
}

export const priceLists = (state = [], action) => {
  switch (action.type) {
    case types.PRICE_LISTS_PRICE_LIST_LOAD_SUCCESS:
      return action.data
    case types.PRICE_LISTS_PRICE_LIST_ADD_SUCCESS:
      return [
        ...state,
        action.data,
      ]
    case types.PRICE_LISTS_PRICE_LIST_UPDATE_SUCCESS:
      return action.data
    default:
      return state // loaded via hydration only
  }
}

export const partCategories = (state = [], action) => {
  switch (action.type) {
    case types.PRICE_LISTS_PART_CATEGORIES_LOAD_SUCCESS:
      return action.data
    case types.PRICE_LISTS_PART_CATEGORY_ADD_SUCCESS:
      return [...state, action.data.result]
    case types.PRICE_LISTS_PRICE_LIST_ADD_SUCCESS:
      return [...state, action.data.rootCategory]
    case types.PRICE_LISTS_PART_CATEGORY_UPDATE_SUCCESS:
      return state.map(category => category.id === action.data.id ? action.data : category)
    default:
      return state
  }
}

export const pricingGroups = (state = [], action) => {
  switch (action.type) {
    case types.PRICE_LISTS_PRICING_GROUPS_LOAD_SUCCESS:
      return action.data
    case types.PRICE_LISTS_PRICING_GROUPS_ADD_SUCCESS:
      return [
        ...state,
        action.data,
      ]
    case types.PRICE_LISTS_PRICING_GROUPS_UPDATE_SUCCESS:
      const updatedPricingGroup = action.data[0]
      return state.map(pricingGroup => {
        return pricingGroup.id === updatedPricingGroup.id
            ? updatedPricingGroup
            : pricingGroup
      })
    case types.PRICE_LISTS_PRICING_GROUPS_DELETE_SUCCESS:
      return state.filter(pricingGroup => pricingGroup.id !== action.data.id)
    default:
      return state // loaded via hydration only
  }
}

export const partTemplates = (state = []) => {
  return state  // loaded via hydration only
}

export const pricingTemplates = (state = [], action) => {
  switch (action.type) {
    case types.PRICE_LISTS_ADD_PRICING_TEMPLATE_SUCCESS:
      return [
        ...state,
        action.data.result[0],
      ]
    case types.PRICE_LISTS_UPDATE_PRICING_TEMPLATE_SUCCESS:
      const updatedPricingTemplate = action.data.result[0]
      return state
          .slice()
          .map(pricingTemplate => {
            return pricingTemplate.id === updatedPricingTemplate.id
                ? updatedPricingTemplate
                : pricingTemplate
          })
    case types.PRICE_LISTS_DELETE_PRICING_TEMPLATE_SUCCESS:
      return state.filter(pricingTemplate => pricingTemplate.id !== action.data.id)
    default:
      return state // loaded via hydration only
  }
}

export const sessionId = (state = null) => state

export const v2Uri = (state = '') => {
  return state
}

export const globalLayouts = (state = []) => {
  return state
}

export const layouts = (state = [], action) => {
  switch (action.type) {
    case types.LOAD_LAYOUTS_SUCCESS:
      return action.layouts
    case types.SAVE_LAYOUT_SUCCESS:
      return [
        ...state,
        action.data,
      ]
    case types.UPDATE_LAYOUT_SUCCESS:
      return state.map(layout => layout.id === action.data.id ? action.data : layout)
    default:
      return state
  }
}

export const locationTypes = (state = []) => {
  return state  // loaded via hydration only
}

export const referralTypes = (state = []) => {
  return state  // loaded via hydration only
}

export const tawkAPIKey = (state = '') => {
  return state  // loaded via hydration only
}

export const googleMapsAPIKey = (state = '') => {
  return state  // loaded via hydration only
}

export const recaptchaSiteKey = (state = '') => {
  return state  // loaded via hydration only
}

export const trialPeriod = (state = '') => {
  return state  // loaded via hydration only
}

export const minPasswordLength = (state = '') => {
  return state  // loaded via hydration only
}

export const quickBooksBaseURL = (state = '') => {
  return state
}

export const paymentDetails = (state = [], action) => {
  switch (action.type) {
    case types.PAYMENT_METHOD_LOAD_ATTEMPT:
      return []
    case types.PAYMENT_METHOD_LOAD_SUCCESS: {
      const paymentDetail = get(action, 'data', null)
      return isNil(paymentDetail)
          ? []
          : [paymentDetail]
    }
    case types.PAYMENT_METHOD_LOAD_FAILURE:
      return []
    default:
      return state
  }
}

export const teams = (state = [], action) => {
  switch (action.type) {
    case types.SETTINGS_LOAD_TEAMS_SUCCESS:
      return action.data
    case types.SETTINGS_ADD_TEAM_SUCCESS:
      return [
        ...state,
        action.data,
      ]
    case types.SETTINGS_UPDATE_TEAM_SUCCESS:
      return state.map(team => {
        return team.id === action.data.id
            ? action.data
            : team
      })
    case types.SETTINGS_DELETE_TEAM_SUCCESS:
      return deleteTeam(action.teamId, state)
    default:
      return state
  }
}

export const teamMembers = (state = [], action) => {
  switch (action.type) {
    case types.SETTINGS_LOAD_TEAM_MEMBERS_SUCCESS:
      return action.data
    case types.SETTINGS_UPDATE_TEAM_MEMBER_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const plansUrl = (state = 'https://clarity-software.com/pricing/') => {
  return state
}

export const error = (state = null, action) => {
  switch (action.type) {
    case types.CONFIG_LOAD_FAILURE:
      return action.error
    default:
      return state
  }
}

export const serviceHealth = (state = null, action) => {
  switch (action.type) {
    case types.SERVICE_HEALTH_LOAD_SUCCESS:
      return action.data
    default:
      return state
  }
}

export const accountingDepartments = (state = []) => {
  return state // loaded via hydration only
}

export default combineReducers({
  accountingDepartments,
  accountPackages,
  activityTypes: createDataBlockReducer([baseAsyncTypes.DATA_LOAD_ACTIVITY_TYPES,
    baseAsyncTypes.SETTINGS_ACTIVITY_TYPE_UPDATE,
    baseAsyncTypes.SETTINGS_ACTIVITY_TYPE_ADD,
    baseAsyncTypes.SETTINGS_ACTIVITY_TYPE_DELETE])([]),
  activityResourceTypes: createDataBlockReducer([baseAsyncTypes.DATA_LOAD_ACTIVITY_RESOURCE_TYPES,
    baseAsyncTypes.SETTINGS_ACTIVITY_RESOURCE_TYPE_UPDATE,
    baseAsyncTypes.SETTINGS_ACTIVITY_RESOURCE_TYPE_ADD,
    baseAsyncTypes.SETTINGS_ACTIVITY_RESOURCE_TYPE_DELETE])([]),
  activityResources: createDataBlockReducer([baseAsyncTypes.DATA_LOAD_ACTIVITY_RESOURCES,
    baseAsyncTypes.SETTINGS_ACTIVITY_RESOURCE_UPDATE,
    baseAsyncTypes.SETTINGS_ACTIVITY_RESOURCE_ADD,
    baseAsyncTypes.SETTINGS_ACTIVITY_RESOURCE_DELETE])([]),
  activityReasons: createDataBlockReducer(
      [baseAsyncTypes.DATA_LOAD_ACTIVITY_REASONS])([]),
  additionalSendAddressDomains,
  baseEmailDomain,
  billingDetails,
  billingInvoices,
  hasMoreBillingInvoices,
  homeCompanyLocations,
  businessTypes,
  campaigns,
  campaignGroups,
  companyFields,
  companyGroups,
  contactFields,
  contactLists,
  contactListCategories,
  contactMethods,
  contactRoles,
  countries,
  currencies,
  defaultCurrencies,
  deliveryMethods: createDataBlockReducer(
      [baseAsyncTypes.DATA_LOAD_DELIVERY_METHODS])([]),
  deliveryReturnReasons: createDataBlockReducer(
      [baseAsyncTypes.DATA_LOAD_DELIVERY_RETURN_REASONS])([]),
  features,
  featureTogglesUri,
  fieldOptions,
  homeContacts,
  individualFields,
  isDomainRestricted,
  globalLayouts,
  layouts,
  locationTypes,
  maxSendAddresses,
  minPasswordLength,
  nominalCodes,
  notifications: createDataBlockReducer(baseAsyncTypes.DATA_LOAD_NOTIFICATIONS)(),
  orderReasons,
  orderTypes,
  opportunityStages: createDataBlockReducer(
      [baseAsyncTypes.DATA_OPPORTUNITY_STAGES_LOAD])([]),
  packages,
  packTypes,
  partTemplates,
  permissions,
  prefixTypes,
  priceLists,
  partCategories,
  pricingGroups,
  pricingTemplates,
  printTemplates,
  printTemplateGroups,
  productionReasons: createDataBlockReducer(
      [baseAsyncTypes.DATA_LOAD_PRODUCTION_REASONS])([]),
  products,
  paymentDetails,
  plansUrl,
  purchasingFields,
  purchasingItemFields,
  quotationFields,
  quotationItemFields,
  recaptchaSiteKey,
  referralFeeValues,
  referralTypes,
  sendAddresses,
  serviceHealth,
  sessionId,
  stateLoaded,
  supportPhone,
  systemName,
  tawkAPIKey,
  googleMapsAPIKey,
  quickBooksBaseURL,
  taxCodes,
  textTemplates,
  teams,
  teamMembers,
  trialPeriod,
  v2Uri,
  error,
})
